import React, { Component } from 'react';
import Search from './components/search/Search'
import ResultItem from './components/results/ResultItem'
import AgentHeader from './components/AgentHeader'
import MapView from './components/results/MapView'
import EditButton from './components/EditButton'
import PropertyTypeFilter from './components/search/PropertyTypeFilter'
import axios from 'axios'
import notification from 'antd/lib/notification'
import message from 'antd/lib/message'
import Modal from 'antd/lib/modal'
import Qs from 'qs'

const listingsPerPage = 8
class App extends Component {
  constructor(props) {
    super(props)

    this.swiper = null
    this.swiperRef = React.createRef()
    this.resultsRef = React.createRef()
    const results = []
    const resultsById = {}
    this.searchType = window.gwSearch.searchType
    this.searchTitle = window.gwSearch.searchTitle
    this.searchDesc = window.gwSearch.searchDesc
    this.uriParams = this.getUriParams()
    this.tabs = window.gwSearch.tabs
    this.fieldsToRemove = window.gwSearch.fieldsToRemove
    this.userCanViewEnquiries = window.gwSearch.userCanViewEnquiries
    this.showPriceEdit = window.gwSearch.showPriceEdit
    this.showSubTitleEdit = window.gwSearch.showSubTitleEdit
    this.showCatEdit = window.gwSearch.showCatEdit
    this.priceEditSwitchContainer = null
    this.offmarketId = window.gwSearch.offmarketId
    this.offmarketTerm = window.gwSearch.offmarketTerm
    this.ajaxUrl = window.gwSearch.ajaxUrl

    // if we can edit the price, make sure there's a node to append the switch to
    if (this.showPriceEdit || this.showSubTitleEdit || this.showCatEdit) {
      const priceEditSwitchContainer = document.getElementById('property-edit-switch-container')
      if (!priceEditSwitchContainer) {
        this.showPriceEdit = false
        this.showSubTitleEdit = false
        this.showCatEdit = false
      }
      this.priceEditSwitchContainer = priceEditSwitchContainer
    }

    window.gwSearch.properties.forEach(result => {
      results.push(result.post_id)
      resultsById[result.post_id] = result
    })

    // handle the sort options
    this.extraSortOptions = []
    // if (this.userCanViewEnquiries) this.extraSortOptions.push({
    //   label: window.gwSearch.strings.sort_by_enquiriesHighest,
    //   value: 'enquiriesHighest',
    // })

    // check for any default params
    let defSortBy = window.gwSearch.view === 'carousel' ? 'none' : 'latest'
    const validSortBy = ['priceLowest', 'priceHighest', 'latest', 'enquiriesHighest', 'availableDate']
    if (this.uriParams.sortBy && validSortBy.indexOf(this.uriParams.sortBy) > -1) defSortBy = this.uriParams.sortBy

    // let defResultsView = ['carousel', 'agent'].includes(window.gwSearch.view) ? window.gwSearch.resultsView : 'list_view'
    let defResultsView = window.gwSearch.resultsView
    const validViews = ['grid_view', 'map_view', 'list_view']
    if (this.uriParams.resultsView && validViews.indexOf(this.uriParams.resultsView) > -1) defResultsView = this.uriParams.resultsView

    this.state = {
      results,
      resultsById,
      sortBy: defSortBy,
      isSearching: false,
      searchData: {
        type: window.gwSearch.activeTab,
        ...window.gwSearch.formDefaults,
      },
      maxListings: this.uriParams.maxListings ? parseInt(this.uriParams.maxListings, 10) : listingsPerPage,
      view: window.gwSearch.view,
      resultsView: defResultsView,
      agentName: window.gwSearch.agentName,
      agentListingTab: 'current',
      initialAgentListingTab: false,
      supportsMixBlendMode: window.getComputedStyle(document.body).mixBlendMode,
      elOffset: 1,
      mapsLoaded: false,
      editing: false,
      propertiesToUpdate: {},
      propertiesToRemove: [],
      saving: false,
      activeFilter: 'all'
    }
    
    // configure the message service
    message.config({
      top: 50,
    })
  }

  componentDidMount() {
    this.maybeInitSwiper()
    this.computeListingOffset()
    window.addEventListener('resize', this.computeListingOffset)
    this.pollForMap()
  }

  componentDidUpdate() {
    this.maybeInitSwiper()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.computeListingOffset)
  }

  pollForMap = () => {
    if (window.google && window.google.maps) return this.setState({
      ...this.state,
      mapsLoaded: true
    })
    setTimeout(this.pollForMap, 500)
  }

  /**
   * Returns all URI params
   */
  getUriParams() {
    return document.location.search
      .replace(/(^\?)/, '')
      .split("&")
      .map(function (n) {
        n = n
          .replace(/%5b/, '[') // we don't want to uridecode the whole thing, but sometimes links are being transformed in emails
          .replace(/%5d/, ']')

        n = n.split("=")
        if (!n[0] || !n[1]) return this
        const val = decodeURIComponent(n[1])

        // is this an array?
        if (n[0].indexOf('[]') > -1) {
          n[0] = n[0].replace('[]', '')
          if (!this[n[0]]) this[n[0]] = []
          this[n[0]].push(val)
        } else {
          this[n[0]] = val
        }
        return this
      }.bind({}))[0]
  }

  /**
   * Persists our search state
   */
  updateUri = (state) => {
    if (!window.history && !window.history.pushState) return
    // first get any existing params
    const params = this.getUriParams()
    const newParams = {}
    const searchData = state.searchData
    const searchKeys = Object.keys(searchData)

    // then add in our search
    searchKeys.forEach(key => {
      if (!searchData[key] || (Array.isArray(searchData[key]) && !searchData[key].length)) return
      newParams[key] = searchData[key]
    })

    // add in anything extra
    Object.keys(params).forEach(key => {
      // only add it if it's not in our searchKeys, so we don't overwrite it
      if (searchKeys.indexOf(key) === -1) newParams[key] = params[key]
    })

    // update the maxListings
    newParams.maxListings = state.maxListings

    // update the sort
    newParams.sortBy = state.sortBy

    // update the results view
    newParams.resultsView = state.resultsView

    // now map out each uri component
    const queryString = Object.keys(newParams).map(key => {
      if (!Array.isArray(newParams[key])) return `${key}=${encodeURIComponent(newParams[key])}`
      return newParams[key].reduce((prev, cur) => {
        const curVal = `${key}[]=${encodeURIComponent(cur)}`
        return prev ? `${prev}&${curVal}` : curVal
      }, '')
    })
      .join('&')

    const href = window.location.href.split('?')[0]
    window.history.pushState({}, '', `${href}?${queryString}`)
  }

  /**
   * ensures that we always have enough listings
   */
  computeListingOffset = () => {
    const containerWidth = this.resultsRef.current.offsetWidth
    const children = this.resultsRef.current.getElementsByClassName('result-item')
    if (children.length === 0) {
      this.setState({
        ...this.state,
        elOffset: 1
      })
      return
    }

    // figure out how many will fit
    const offset = Math.floor(containerWidth / children[0].offsetWidth)
    this.setState({
      ...this.state,
      elOffset: offset,
    })
  }

  /**
   * Maybe re-renders the swiper
   */
  maybeInitSwiper = () => {
    if (this.state.view !== 'carousel') return
    // destroy the current instance
    if (this.swiper !== null) this.swiper.destroy()
    this.swiper = new window.Swiper(this.swiperRef.current, {
      slidesPerView: 'auto',
      spaceBetween: 30,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    })
  }

  /**
   * Runs when the user clicks the "search" button
   */
  onSearch = (state) => {
    // firstly update our state
    const newState = {
      ...this.state,
      // maxListings: listingsPerPage,
      searchData: {
        ...state,
      },
    }
    this.setState(newState)
    this.updateUri(newState)
  }

  /**
   * Runs when the user hits the "load more" button
   */
  onLoadMore = () => {

  }

  /**
   * Asserts whether a value is between the specified vals
   * if the range is undefined it is automatically true
   */
  valIsBetween(val, range) {
    if (!range) return true
    return val >= range[0] && val <= range[1]
  }

  /**
   * Asserts whether a value exists within a list
   * if the list is empty, then it's true
   */
  valExistsInList(val, list) {
    if (!list || list.length === 0) return true
    // numbers are often turned into strings, so let's convert them
    if (typeof val === 'number') val = val.toString()
    return list.indexOf(val) > -1
  }

  /**
   * Asserts whether a passed string exists on various properties either in full or in part
   */
  valExistsInStringList(val, strings) {
    if (!val || val.length === 0) return true
    return strings.some(str => {
      return str.toLowerCase().indexOf(val.toLowerCase()) > -1
    })
  }

  /**
   * returns only the relevant listings to filter
   */
  filteredListings = () => {
    // if we're viewing a slideshow we don't need to filter anything
    if (this.state.view === 'carousel') return this.state.results

    const s = this.state.searchData
    // return only the listings applicable to us
    const filtered = this.state.results.filter(id => {
      
      const property = this.state.resultsById[id]
      // if we're viewing agents, we don't need to do all this other filtering
      if (this.state.view === 'agent') {
        if (this.state.agentListingTab === 'sales') {
          return property.listing_type === 'sales' && property.property_status === 'current' && property.property_status_text !== 'Sold' ;
        }
        if (this.state.agentListingTab === 'current') {
          return property.listing_type === 'residential' && property.property_status === 'current';
        }

        if (this.state.agentListingTab === 'sold') {
          return property.property_status_text === 'Sold'
        }


        return property.property_status === this.state.agentListingTab
      }
      if (property.listing_type !== s.type) return false

      // filter ranges
      if (!(this.valIsBetween(property.rent_per_week, s.price) || (property.rent_per_week_max > 0 && this.valIsBetween(property.rent_per_week_max, s.price)))) return false
      if (!this.valIsBetween(property.bedroom_count, s.bedrooms)) return false
      if (!this.valIsBetween(property.bathroom_count, s.bathrooms)) return false
      if (!this.valIsBetween(property.land_size, s.land_size)) return false
      if (!this.valIsBetween(property.floor_size, s.floor_size)) return false

      // filter selects
      if (property.suburbs && property.suburbs.length && !this.valExistsInList(property.suburbs[0].term_id, s.suburbs)) return false
      if (property.property_type && !this.valExistsInList(property.property_type.term_id, s.property_type)) return false

      // search text fields
      if (!this.valExistsInStringList(s.keyword, [property.address, property.property_id, property.suburb_string, property.display_title, property.description])) return false

      // check fully furnished
      if (s.fully_furnished && !property.fully_furnished) return false

      // check availability
      if (s.available_now && !property.available_now) return false

      // check pets OK
      if (s.pets_ok && !property.pets_ok) return false
      return true
    })
      .sort(this.sortListings)


    // if we are showing agent leased listings, only display four
    if (this.state.view === 'agent' && this.state.agentListingTab === 'leased') return filtered.slice(0, 4)
    // if sort is by latest listings, re-arrange put the properties on sales first
    if(this.state.sortBy === 'latest') return this.salesFirst(filtered);

    return filtered;
  }

  /**
   * Handles the sorting of listings
   */
  sortListings = (a, b) => {
    // if we're viewing a slideshow, then don't sort at all
    if (this.state.view === 'carousel') return 0
    const propA = this.state.resultsById[a]
    const propB = this.state.resultsById[b]
    switch (this.state.sortBy) {
      case 'availableDate':
        return propA.date_available - propB.date_available
      case 'priceLowest':
        return propA.rent_per_week - propB.rent_per_week
      case 'latest':
        return propB.time_created - propA.time_created
      case 'enquiriesHighest':
        return propB.enquiry_count - propA.enquiry_count
      default:
        // default to highest price
        const aPrice = propA.rent_per_week_max || propA.rent_per_week
        const bPrice = propB.rent_per_week_max || propB.rent_per_week
        return bPrice - aPrice
    }
  }

  /**
   * Re-arrange sales listing. Put the property on sales first and sold property after
   */
  salesFirst = (filteredProperties) =>{
    const onSales = [];
    const onSold = [];
    
    filteredProperties.forEach((id)=>{
      const property = this.state.resultsById[id]

      if (property.property_status_text === "Sold") {
        onSold.push(id);
      }else{
        onSales.push(id);
      }
    })
    return  onSales.concat(onSold);
  }


  /**
   * Runs when the user changes the "sort"
   */
  onSortChange = (sort) => {
    const newState = {
      ...this.state,
      sortBy: sort,
    }
    this.setState(newState)
    this.updateUri(newState)
  }

  onViewChange = (view) => {
    const newState = {
      ...this.state,
      resultsView: view,
    }
    this.setState(newState)
    this.updateUri(newState)
  }

  renderResults = (listings) => {
    if (listings.length === 0) return <div className="search-no-results">{window.gwSearch.strings.no_results}</div>
    const results = []
    listings.some((id, idx) => {
      const resultItem = (
        <ResultItem
          key={id}
          property={this.state.resultsById[id]}
          strings={window.gwSearch.strings}
          supportsMixBlendMode={this.state.supportsMixBlendMode}
          swiperItem={this.state.view === 'carousel'}
          fieldsToRemove={this.fieldsToRemove}
          editing={this.state.editing}
          onUpdate={this.onUpdate}
          onRemove={this.onRemove}
          onRemoveRestore={this.onRemoveRestore}
          propertiesToRemove={this.state.propertiesToRemove}
          showPriceEdit={this.showPriceEdit}
          showSubTitleEdit={this.showSubTitleEdit}
          showCatEdit={this.showCatEdit}
        />
      )
      results.push(resultItem)
      if (this.state.view === 'carousel') return false
      return (idx+1) >= this.state.maxListings
    })
    // add in any spacers
    if (this.state.elOffset <= 1) return results
    const extraEls = results.length % this.state.elOffset
    if (extraEls === 0) return results
    for (let i = 0; i < this.state.elOffset - extraEls; i++) {
      results.push(<div key={`spacer-${i}`} className="result-item result-spacer" />)
    }
    return results
  }

  onAgentTabChange = (tab) => {
    this.setState({
      ...this.state,
      agentListingTab: tab,
    })
  }

  /**
   * conditionally renders the search form or the agent header, whichever is appropriate
   */
  renderHeader = (results) => {
    switch (this.state.view) {
      case 'agent':

        let agentProperties = {
          current: null,
          leased: null,
          sales: null,
          sold: null
        }

        // get all properties that are currently on lease for this agent
        agentProperties.current = this.state.results.filter(id => {
          const property = this.state.resultsById[id];
          if (property.property_status === "current" && property.listing_type === "residential") {
            return true;
          }
        })
        // get all properties that are leased for this agent
        agentProperties.leased = this.state.results.filter(id => {
          const property = this.state.resultsById[id];
          if (property.property_status === "leased")  {
            return true;
          }
        })
        // get all properties that are on sales for this agent
        agentProperties.sales = this.state.results.filter(id => {
          const property = this.state.resultsById[id];
          if (property.listing_type === "sales")  {
            return true;
          }
        })
        // get all properties that are sold for this agent
        agentProperties.sold = this.state.results.filter(id => {
          const property = this.state.resultsById[id];
          if (property.property_status_text === 'Sold')  {
            return true;
          }
        })


        

        //return first available tab
        // Loop through the properties of the agentProperties object
        for (const propertyName in agentProperties) {
          if(agentProperties[propertyName].length !== 0 && this.state.initialAgentListingTab === false){
            this.setState({
              agentListingTab: propertyName,
              initialAgentListingTab: true
              
            })
            break;
          }
        }

        return <AgentHeader agentProperties={agentProperties} agentName={window.gwSearch.agentName} strings={window.gwSearch.strings} onAgentTabChange={this.onAgentTabChange} currentTab={this.state.agentListingTab} />
      case 'carousel':
        return <div className="gw-search__carousel-header"><span className="h2">{window.gwSearch.viewTitle}</span><div className="swiper-button-prev" /><div className="swiper-button-next" /></div>
      default:
        return <Search
          uriParams={this.uriParams}
          formParams={window.gwSearch.formParams}
          strings={window.gwSearch.strings}
          onSearch={this.onSearch}
          results={results}
          sortBy={this.state.sortBy}
          onSort={this.onSortChange}
          onViewChange={this.onViewChange}
          resultsView={this.state.resultsView}
          view={this.state.view}
          tabs={this.tabs}
          searchTitle={this.searchTitle}
          extraSortOptions={this.extraSortOptions}
          searchDesc={this.searchDesc} />
    }
  }

  /**
   * Increases the max listings 
   */
  addMoreListings = (e) => {
    e.preventDefault()
    const newState = {
      ...this.state,
      maxListings: this.state.maxListings + listingsPerPage,
    }
    this.setState(newState)
    this.updateUri(newState)
  }

  /**
   * conditionally renders the load more button
   */
  renderLoadMore = (results) => {
    if (this.state.view === 'carousel' || results.length < listingsPerPage || this.state.maxListings >= results.length) return
    return (
      <div className="gw-search__more-wrap">
        <a className="avia-button avia-color-theme-color" onClick={this.addMoreListings}>{window.gwSearch.strings.load_more}</a>
      </div>
    )
  }

  /**
   * conditionally renders the view all properties button
   */
  renderViewAllProperties = () => {
    if (this.state.view !== 'carousel') return
    return (
      <div className="gw-search__view_all-wrap">
        <a className="avia-button avia-color-theme-color" href="/property-search">{window.gwSearch.strings.view_all_properties}</a>
      </div>
    )
  }

  onRemove = (id) => {
    if (this.state.propertiesToRemove.indexOf(id) === -1) this.setState({
      ...this.state,
      propertiesToRemove: [
        ...this.state.propertiesToRemove,
        id
      ]
    })
  }

  onRemoveRestore = (id) => {
    const idx = this.state.propertiesToRemove.indexOf(id)
    if (id === -1) return
    const properties = [...this.state.propertiesToRemove]
    properties.splice(idx, 1)
    this.setState({
      ...this.state,
      propertiesToRemove: properties
    })
  }

  onUpdate = (id, data) => {
    this.setState({
      ...this.state,
      propertiesToUpdate: {
        ...this.state.propertiesToUpdate,
        [id]: {
          ...this.state.propertiesToUpdate[id],
          ...data,
        },
      },
    })
  }

  onSetEditing = (edit) => {
    const newState = {
      ...this.state,
      editing: edit,
    }

    // if we are setting the edit to false, then also reset the prices to update
    if (edit === false) {
      newState.propertiesToUpdate = {}
    }

    this.setState(newState)
  }

  onSaveUpdates = () => {
    if (this.state.saving) return

    // if we have properties to remove, confirm first
    if (this.state.propertiesToRemove.length) {
      Modal.confirm({
        title: 'Are you sure you want to remove these properties?',
        content: 'You have properties queued for removal. If you don\'t want to remove them, cancel and restore them. Once removed, properties can only be restored by a Goodwins staff member',
        zIndex: 9999,
        onOk: () => {
          this.runSaveUpdates()
          return Promise.resolve()
        },
        onCancel() { },
      })
    } else {
      this.runSaveUpdates()
    }
  }

  runSaveUpdates = () => {
    // first set the loading state and start the save process
    this.setState({
      ...this.state,
      saving: true,
    }, this.saveUpdates)
  }

  saveUpdates = async () => {
    const hide = message.loading('Saving...', 0)
    try {
      // save the updates
      const response = await axios.post(this.ajaxUrl, Qs.stringify({
        updates: this.state.propertiesToUpdate,
        removals: this.state.propertiesToRemove,
        action: 'update_offmarket_properties',
        om_uid: this.offmarketId,
        om_term: this.offmarketTerm,
        om_link: null
      }));

      // update the prices visually in the app
      const newState = {
        ...this.state,
        saving: false,
        editing: false,
        resultsById: {
          ...this.state.resultsById,
        },
        propertiesToRemove: [],
        propertiesToUpdate: {},
      }

      const updateFields = ['rent_per_week', 'display_price', 'display_subtitle'];
      Object.keys(response.data.updates).forEach(resultId => {
        updateFields.forEach(updateField => {
          if (response.data.updates[resultId][updateField] !== null) newState.resultsById[resultId][updateField] = response.data.updates[resultId][updateField];
        })
      })

      // remove any properties
      response.data.removed.forEach(postId => {
        const idx = newState.results.indexOf(postId)
        if (idx > -1) {
          newState.results.splice(idx, 1)
          delete newState.resultsById[postId]
        }
      })

      // update the state to not be editing
      this.setState(newState)
    } catch (e) {
      console.log(e)
      notification.open({
        message: 'Oops!',
        description: 'Sorry, there was an error saving pricing. Please try again and let us know if the issue persists.',
      })
      this.setState({
        ...this.state,
        saving: false,
      })
    } finally {
      hide()
    }
  }

  // Add filter change handler
  handleFilterChange = (filterType) => {
    this.setState({ activeFilter: filterType }, () => {
      const filteredResults = window.gwSearch.properties.filter(property => {
        if (filterType === 'all') return true;
        if (filterType === 'sales') return property.listing_type === 'sales';
        if (filterType === 'rentals') return property.listing_type === 'residential';
        return true;
      });
      
      // Debug logging
      console.log('Filter type:', filterType);
      console.log('Filtered results:', filteredResults);
      
      // Update the results
      this.setState({
        results: filteredResults.map(p => p.post_id)
      });
    });
  }

  render() {
    const results = this.filteredListings()
    

    const list_view = this.state.resultsView === 'list_view' ? 'list-view' : ''

    const isSwiper = this.state.view === 'carousel'
    const swiperClassRoot = isSwiper ? 'swiper-container' : ''
    const swiperClassWrap = isSwiper ? 'swiper-wrapper' : ''
    const enquiryClass = this.userCanViewEnquiries ? 'user--has-enquires' : 'user--no-enquiries'
    const map = this.state.resultsView === 'map_view' && this.state.mapsLoaded && results.length ? <MapView results={results} resultsById={this.state.resultsById} strings={window.gwSearch.strings} supportsMixBlendMode={this.state.supportsMixBlendMode} fieldsToRemove={this.fieldsToRemove} /> : null
    const PriceButton = this.showPriceEdit || this.showSubTitleEdit || this.showCatEdit ?
      <EditButton
        portalContainer={this.priceEditSwitchContainer}
        onSetEditing={this.onSetEditing}
        onSaveUpdates={this.onSaveUpdates}
        isEditing={this.state.editing} /> :
      null
    return (
      <div className={`gw-search-root ${swiperClassRoot} search-type-${this.searchType} ${enquiryClass}`} ref={this.swiperRef}>
        {PriceButton}
        {this.renderHeader(results)}
        {isSwiper && window.gwSearch.showPropertyTypeFilter && (
          <div className="property-type-filter-container" style={{ marginBottom: '20px', textAlign: 'center' }}>
            <PropertyTypeFilter 
              onFilterChange={this.handleFilterChange}
              activeFilter={this.state.activeFilter}
            />
          </div>
        )}
        {map}
        <div className={`gw-search__results ${list_view} ${swiperClassWrap}`} ref={this.resultsRef}>
          {this.renderResults(results)}
        </div>
        {this.renderViewAllProperties()}
        {this.renderLoadMore(results)}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js